import { render } from "./LoginFormPatient.vue?vue&type=template&id=32da31ad&scoped=true"
import script from "./LoginFormPatient.vue?vue&type=script&lang=js"
export * from "./LoginFormPatient.vue?vue&type=script&lang=js"

import "./LoginFormPatient.vue?vue&type=style&index=0&id=32da31ad&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32da31ad"]])

export default __exports__